import { Route, Routes } from "react-router-dom";
import NavBar from "./components/NavBar";
import WelcomePage from "./pages/WelcomPage";

function App() {
  return (
    <div id="page-wrapper">
      <NavBar />
      <Routes>
        <Route path="/" element={<WelcomePage />}></Route>
      </Routes>
    </div>
  );
}

export default App;
